/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online URL encoder and decoder. Percent-encode text for query strings, or decode encoded URLs back to plain text, with full Unicode support. Nothing is uploaded.`)
};

const es_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador y decodificador de URL gratuito en línea. Codifica texto en porcentaje para cadenas de consulta, o decodifica URL codificadas en texto sin formato, con soporte completo de Unicode. Nada se carga.`)
};

const de_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-URL-Kodierer und Dekoder. Kodieren Sie Text mit Prozentzeichen für Query Strings, oder dekodieren Sie kodierte URLs zurück zu reinem Text, mit vollständiger Unicode-Unterstützung. Nichts wird hochgeladen.`)
};

const nl_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online URL-encoder en -decoder. Percent-codeer tekst voor querystrings, of decodeer gecodeerde URL's terug naar platte tekst, met volledige Unicode-ondersteuning. Niets wordt geüpload.`)
};

const fr_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodeur et décodeur URL en ligne gratuit. Encodez le texte en pourcentage pour les chaînes de requête, ou décodez les URL encodées en texte brut, avec support Unicode complet. Rien n'est téléchargé.`)
};

const it_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificatore e decodificatore URL online gratuito. Codifica in percentuale il testo per le stringhe di query, o decodifica gli URL codificati in testo normale, con supporto Unicode completo. Nulla viene caricato.`)
};

const pt_br2_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e decodificador de URL online gratuito. Codifique por porcentagem texto para strings de consulta, ou decodifique URLs codificadas para texto simples, com suporte Unicode completo. Nada é enviado.`)
};

const pt_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador e descodificador de URL gratuito online. Codifique em percentual o texto para strings de consulta, ou descodifique URLs codificadas de volta para texto simples, com suporte completo a Unicode. Nada é carregado.`)
};

const ja_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインURLエンコーダーとデコーダー。テキストをパーセント エンコードしてクエリ文字列に対応させるか、エンコードされたURLをプレーン テキストにデコードします。完全なUnicode サポート付き。アップロードされるものはありません。`)
};

const zh_ue_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 URL 编码器和解码器。为查询字符串对文本进行百分号编码，或将编码后的 URL 解码回纯文本，支持完整的 Unicode。不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_meta_description", locale)
	if (locale === "en") return en_ue_meta_description(inputs)
	if (locale === "es") return es_ue_meta_description(inputs)
	if (locale === "de") return de_ue_meta_description(inputs)
	if (locale === "nl") return nl_ue_meta_description(inputs)
	if (locale === "fr") return fr_ue_meta_description(inputs)
	if (locale === "it") return it_ue_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ue_meta_description(inputs)
	if (locale === "pt") return pt_ue_meta_description(inputs)
	if (locale === "ja") return ja_ue_meta_description(inputs)
	return zh_ue_meta_description(inputs)
};